import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import CaseType from '../../entities/caseType';
import Matter from '../../entities/matter';
import DeadlineRule from '../../entities/deadlineRule';
import Lead from '../../entities/lead';
import Question from '../../entities/question';
import RedFlagType from '../../entities/redFlagType';
import CaseTypeStage from '../../entities/caseTypeStage';
import FlatFee from '../../entities/flatFee';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
import {deleteCaseTypeStage, collectCaseTypeStageDeleteImpact} from './caseTypeStageDeps';
import {deleteFlatFee, collectFlatFeeDeleteImpact} from './flatFeeDeps';
export function canDeleteCaseType(): boolean {
return canCascadeDelete();
}
export function collectCaseTypeDeleteImpact(caseType: CaseType, context: DeleteImpactContext): void {
const key = 'caseType:' + caseType.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
const matterCaseTypeIdImpact = workingRows<Matter>('matter', findAll<Matter>('matters')).filter(matterRef => matterRef.caseTypeId === caseType.id);
matterCaseTypeIdImpact.forEach(matterRef => addDeleteImpact(context, 'matter:' + matterRef.id, 'matters'));
const deadlineRuleCaseTypeIdImpact = workingRows<DeadlineRule>('deadlineRule', findAll<DeadlineRule>('deadlineRules')).filter(deadlineRuleRef => deadlineRuleRef.caseTypeId === caseType.id);
deadlineRuleCaseTypeIdImpact.forEach(deadlineRuleRef => addDeleteImpact(context, 'deadlineRule:' + deadlineRuleRef.id, 'deadlineRules'));
const leadCaseTypesImpact = workingRows<Lead>('lead', findAll<Lead>('leads')).filter(leadRef => leadRef.caseTypes?.includes(caseType.id));
leadCaseTypesImpact.forEach(leadRef => addDeleteImpact(context, 'lead:' + leadRef.id, 'leads'));
const questionAppliesToImpact = workingRows<Question>('question', findAll<Question>('questions')).filter(questionRef => questionRef.appliesTo?.includes(caseType.id));
questionAppliesToImpact.forEach(questionRef => addDeleteImpact(context, 'question:' + questionRef.id, 'questions'));
const redFlagTypeAppliesToImpact = workingRows<RedFlagType>('redFlagType', findAll<RedFlagType>('redFlagTypes')).filter(redFlagTypeRef => redFlagTypeRef.appliesTo?.includes(caseType.id));
redFlagTypeAppliesToImpact.forEach(redFlagTypeRef => addDeleteImpact(context, 'redFlagType:' + redFlagTypeRef.id, 'redFlagTypes'));workingRows<CaseTypeStage>('caseTypeStage', findAll<CaseTypeStage>('caseTypeStages')).filter(caseTypeStage => caseTypeStage.status !== 'D' && caseTypeStage.caseTypeId === caseType.id).forEach(caseTypeStage => {
if (context.visited.has('caseTypeStage:' + caseTypeStage.id)) return;
addDeleteImpact(context, 'caseTypeStage:' + caseTypeStage.id, 'caseTypeStages');
collectCaseTypeStageDeleteImpact(caseTypeStage, context);
});
workingRows<FlatFee>('flatFee', findAll<FlatFee>('flatFees')).filter(flatFee => flatFee.status !== 'D' && flatFee.entityType === 'caseType' && flatFee.entityId === caseType.id).forEach(flatFee => {
if (context.visited.has('flatFee:' + flatFee.id)) return;
addDeleteImpact(context, 'flatFee:' + flatFee.id, 'flatFees');
collectFlatFeeDeleteImpact(flatFee, context);
});
}
export function deleteImpactCaseType(caseType: CaseType): DeleteImpact {
const context = deleteImpactContext();
collectCaseTypeDeleteImpact(caseType, context);
return deleteImpactCounts(context);
}
export function deleteCaseType(caseType: CaseType, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteCaseType()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectCaseTypeDeleteImpact(caseType, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || caseType.id};
}
const key = 'caseType:' + caseType.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<CaseTypeStage>('caseTypeStage', findAll<CaseTypeStage>('caseTypeStages')).filter(caseTypeStage => caseTypeStage.status !== 'D' && caseTypeStage.caseTypeId === caseType.id).forEach(caseTypeStage => {deleteCaseTypeStage(caseTypeStage, mergeId, cascade);});
workingRows<FlatFee>('flatFee', findAll<FlatFee>('flatFees')).filter(flatFee => flatFee.status !== 'D' && flatFee.entityType === 'caseType' && flatFee.entityId === caseType.id).forEach(flatFee => {deleteFlatFee(flatFee, mergeId, cascade);});
workingRows<Matter>('matter', [...store.getState().matters.getMappingFor('caseTypeId', caseType.id)]).filter(matterTemp => matterTemp.caseTypeId === caseType.id).forEach(matterTemp => {
const _matter = ((_work.get('matter:' + matterTemp.id) ?? matterTemp) as Matter).clone();
if (_matter.status === 'D') return;
_matter.status = 'U';
_matter.addedOn = newHRTimestamp();
_matter.addedBy = getCurrentUserId();
_matter.importSource = targetImportSource;
_matter.importId = mergeId;
if (_matter.caseTypeId === caseType.id) {
_matter.caseTypeId = null;

}
_work.set('matter:' + _matter.id, _matter);
dispatch(Actions.MatterActions.saveMatterQueue(_matter), 'matter:' + _matter.id);
});
workingRows<DeadlineRule>('deadlineRule', [...store.getState().deadlineRules.getMappingFor('caseTypeId', caseType.id)]).filter(deadlineRuleTemp => deadlineRuleTemp.caseTypeId === caseType.id).forEach(deadlineRuleTemp => {
const _deadlineRule = ((_work.get('deadlineRule:' + deadlineRuleTemp.id) ?? deadlineRuleTemp) as DeadlineRule).clone();
if (_deadlineRule.status === 'D') return;
_deadlineRule.status = 'U';
_deadlineRule.addedOn = newHRTimestamp();
_deadlineRule.addedBy = getCurrentUserId();
_deadlineRule.importSource = targetImportSource;
_deadlineRule.importId = mergeId;
if (_deadlineRule.caseTypeId === caseType.id) {
_deadlineRule.caseTypeId = null;

}
_work.set('deadlineRule:' + _deadlineRule.id, _deadlineRule);
dispatch(Actions.DeadlineRuleActions.saveDeadlineRuleQueue(_deadlineRule), 'deadlineRule:' + _deadlineRule.id);
});
workingRows<Lead>('lead', [...store.getState().leads.getMappingFor('caseTypeId', caseType.id)]).filter(leadTemp => leadTemp.caseTypes?.includes(caseType.id)).forEach(leadTemp => {
const _lead = ((_work.get('lead:' + leadTemp.id) ?? leadTemp) as Lead).clone();
if (_lead.status === 'D') return;
_lead.status = 'U';
_lead.addedOn = newHRTimestamp();
_lead.addedBy = getCurrentUserId();
_lead.importSource = targetImportSource;
_lead.importId = mergeId;
_lead.caseTypes = _lead.caseTypes?.filter(id => id !== caseType.id) || [];

_work.set('lead:' + _lead.id, _lead);
dispatch(Actions.LeadActions.saveLeadQueue(_lead), 'lead:' + _lead.id);
});
workingRows<Question>('question', [...store.getState().questions.getMappingFor('appliesTo', caseType.id)]).filter(questionTemp => questionTemp.appliesTo?.includes(caseType.id)).forEach(questionTemp => {
const _question = ((_work.get('question:' + questionTemp.id) ?? questionTemp) as Question).clone();
if (_question.status === 'D') return;
_question.status = 'U';
_question.addedOn = newHRTimestamp();
_question.addedBy = getCurrentUserId();
_question.importSource = targetImportSource;
_question.importId = mergeId;
_question.appliesTo = _question.appliesTo?.filter(id => id !== caseType.id) || [];

_work.set('question:' + _question.id, _question);
dispatch(Actions.QuestionActions.saveQuestionQueue(_question), 'question:' + _question.id);
});
workingRows<RedFlagType>('redFlagType', [...store.getState().redFlagTypes.getMappingFor('appliesTo', caseType.id)]).filter(redFlagTypeTemp => redFlagTypeTemp.appliesTo?.includes(caseType.id)).forEach(redFlagTypeTemp => {
const _redFlagType = ((_work.get('redFlagType:' + redFlagTypeTemp.id) ?? redFlagTypeTemp) as RedFlagType).clone();
if (_redFlagType.status === 'D') return;
_redFlagType.status = 'U';
_redFlagType.addedOn = newHRTimestamp();
_redFlagType.addedBy = getCurrentUserId();
_redFlagType.importSource = targetImportSource;
_redFlagType.importId = mergeId;
_redFlagType.appliesTo = _redFlagType.appliesTo?.filter(id => id !== caseType.id) || [];

_work.set('redFlagType:' + _redFlagType.id, _redFlagType);
dispatch(Actions.RedFlagTypeActions.saveRedFlagTypeQueue(_redFlagType), 'redFlagType:' + _redFlagType.id);
});
const deleted = caseType.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.CaseTypeActions.removeCaseTypeQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceCaseType(caseType: CaseType, replaceWith: CaseType, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = caseType.id;}
const _work = workingSet();
workingRows<Matter>('matter', [...store.getState().matters.getMappingFor('caseTypeId', caseType.id)]).filter(matterTemp => matterTemp.caseTypeId === caseType.id).forEach(matterTemp => {
const _matter = ((_work.get('matter:' + matterTemp.id) ?? matterTemp) as Matter).clone();
if (_matter.status === 'D') return;
_matter.status = 'U';
_matter.addedOn = newHRTimestamp();
_matter.addedBy = getCurrentUserId();
_matter.importSource = targetImportSource;
_matter.importId = mergeId;
if (_matter.caseTypeId === caseType.id) {
_matter.caseTypeId = replaceWith.id;

}
_work.set('matter:' + _matter.id, _matter);
store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
});
workingRows<DeadlineRule>('deadlineRule', [...store.getState().deadlineRules.getMappingFor('caseTypeId', caseType.id)]).filter(deadlineRuleTemp => deadlineRuleTemp.caseTypeId === caseType.id).forEach(deadlineRuleTemp => {
const _deadlineRule = ((_work.get('deadlineRule:' + deadlineRuleTemp.id) ?? deadlineRuleTemp) as DeadlineRule).clone();
if (_deadlineRule.status === 'D') return;
_deadlineRule.status = 'U';
_deadlineRule.addedOn = newHRTimestamp();
_deadlineRule.addedBy = getCurrentUserId();
_deadlineRule.importSource = targetImportSource;
_deadlineRule.importId = mergeId;
if (_deadlineRule.caseTypeId === caseType.id) {
_deadlineRule.caseTypeId = replaceWith.id;

}
_work.set('deadlineRule:' + _deadlineRule.id, _deadlineRule);
store.dispatch(Actions.DeadlineRuleActions.saveDeadlineRuleQueue(_deadlineRule));
});
workingRows<Lead>('lead', [...store.getState().leads.getMappingFor('caseTypeId', caseType.id)]).filter(leadTemp => leadTemp.caseTypes?.includes(caseType.id)).forEach(leadTemp => {
const _lead = ((_work.get('lead:' + leadTemp.id) ?? leadTemp) as Lead).clone();
if (_lead.status === 'D') return;
_lead.status = 'U';
_lead.addedOn = newHRTimestamp();
_lead.addedBy = getCurrentUserId();
_lead.importSource = targetImportSource;
_lead.importId = mergeId;
_lead.caseTypes = _lead.caseTypes?.map(id => (id === caseType.id) ? replaceWith.id : id) || [];

_work.set('lead:' + _lead.id, _lead);
store.dispatch(Actions.LeadActions.saveLeadQueue(_lead));
});
workingRows<Question>('question', [...store.getState().questions.getMappingFor('appliesTo', caseType.id)]).filter(questionTemp => questionTemp.appliesTo?.includes(caseType.id)).forEach(questionTemp => {
const _question = ((_work.get('question:' + questionTemp.id) ?? questionTemp) as Question).clone();
if (_question.status === 'D') return;
_question.status = 'U';
_question.addedOn = newHRTimestamp();
_question.addedBy = getCurrentUserId();
_question.importSource = targetImportSource;
_question.importId = mergeId;
_question.appliesTo = _question.appliesTo?.map(id => (id === caseType.id) ? replaceWith.id : id) || [];

_work.set('question:' + _question.id, _question);
store.dispatch(Actions.QuestionActions.saveQuestionQueue(_question));
});
workingRows<RedFlagType>('redFlagType', [...store.getState().redFlagTypes.getMappingFor('appliesTo', caseType.id)]).filter(redFlagTypeTemp => redFlagTypeTemp.appliesTo?.includes(caseType.id)).forEach(redFlagTypeTemp => {
const _redFlagType = ((_work.get('redFlagType:' + redFlagTypeTemp.id) ?? redFlagTypeTemp) as RedFlagType).clone();
if (_redFlagType.status === 'D') return;
_redFlagType.status = 'U';
_redFlagType.addedOn = newHRTimestamp();
_redFlagType.addedBy = getCurrentUserId();
_redFlagType.importSource = targetImportSource;
_redFlagType.importId = mergeId;
_redFlagType.appliesTo = _redFlagType.appliesTo?.map(id => (id === caseType.id) ? replaceWith.id : id) || [];

_work.set('redFlagType:' + _redFlagType.id, _redFlagType);
store.dispatch(Actions.RedFlagTypeActions.saveRedFlagTypeQueue(_redFlagType));
});



workingRows<CaseTypeStage>('caseTypeStage', findAll<CaseTypeStage>('caseTypeStages')).filter(caseTypeStage => caseTypeStage.status !== 'D' && caseTypeStage.caseTypeId === caseType.id).forEach(caseTypeStageTemp => {
const _caseTypeStage = ((_work.get('caseTypeStage:' + caseTypeStageTemp.id) ?? caseTypeStageTemp) as CaseTypeStage).clone();
if (_caseTypeStage.status === 'D') return;
_caseTypeStage.caseTypeId = replaceWith.id;
_caseTypeStage.status = 'U';
_caseTypeStage.addedOn = newHRTimestamp();
_caseTypeStage.addedBy = getCurrentUserId();
_caseTypeStage.importSource = targetImportSource;
_caseTypeStage.importId = mergeId;
_work.set('caseTypeStage:' + _caseTypeStage.id, _caseTypeStage);
store.dispatch(Actions.CaseTypeStageActions.saveCaseTypeStageQueue(_caseTypeStage));
});
workingRows<FlatFee>('flatFee', findAll<FlatFee>('flatFees')).filter(flatFee => flatFee.status !== 'D' && flatFee.entityType === 'caseType' && flatFee.entityId === caseType.id).forEach(flatFeeTemp => {
const _flatFee = ((_work.get('flatFee:' + flatFeeTemp.id) ?? flatFeeTemp) as FlatFee).clone();
if (_flatFee.status === 'D') return;
_flatFee.entityId = replaceWith.id;
_flatFee.status = 'U';
_flatFee.addedOn = newHRTimestamp();
_flatFee.addedBy = getCurrentUserId();
_flatFee.importSource = targetImportSource;
_flatFee.importId = mergeId;
_work.set('flatFee:' + _flatFee.id, _flatFee);
store.dispatch(Actions.FlatFeeActions.saveFlatFeeQueue(_flatFee));
});
return caseType;
}
